import type { ConfigurationFunctionValueInOut } from '@festina/configuration-general-types/configuration'

import type {
  SubTemplateValueSetupField,
  TemplateVersion,
} from '../../types/templateModel'

export type SubTemplateAddDynamicFunctionFields = {
  parent: SubTemplateValueSetupField
  subTemplateIdentifier: string
}

export type TemplateVersionAddDynamicFunctionFields = {
  parent: TemplateVersion
}

export type AddDynamicFunctionPlaceholder = {
  type: 'addDynamicFunctionPlaceholder'
  addRawFunction: (value: ConfigurationFunctionValueInOut) => void
} & (
  | SubTemplateAddDynamicFunctionFields
  | TemplateVersionAddDynamicFunctionFields
)

export const isAddDynamicFunctionPlaceholder = (
  value: Record<string, unknown>,
): value is AddDynamicFunctionPlaceholder =>
  'type' in value && value['type'] === 'addDynamicFunctionPlaceholder'
